// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
//子订单
import  childrenOrder from  "@/views/pay/childrenOrder"
// 虚拟实时订单
import fakeOrder from '@/views/pay/fakeOrder';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import loginLogs from '@/views/system/loginLogs';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';

// 图片维护--------------------------------------
import IndexSwiper from '@/views/img/IndexSwiper';
// 登录协议
import protocol from '@/views/img/protocol';
//搜索热词维护
import hotSearch from '@/views/img/hotSearch'
import dicType from '@/views/system/dicType';
import dicList from '@/views/system/dicList';
// 用户
import appUser from '@/views/system/appUser';
// vip用户
import vipUser from '@/views/system/vipuser';
// 用户
import userCenter from '@/views/system/userCenter';
// 商品管理
import productList from '@/views/product/list';
import Typelist from '@/views/product/typeList';
// 推荐列表
import recommendList from '@/views/product/recommendList';
// 国旗管理
import nationalFlag from '@/views/product/nationalFlag';
// 产品品牌
import brands from '@/views/product/brands';
// 产品标签
import tags from '@/views/product/tags';
// 生产厂家
import factorys from '@/views/product/factorys';

// 退单管理
import refund from '@/views/pay/refund';
// 云仓 极光
import aurora from '@/views/cloudStore/aurora';
// 麦帮
import meibang from '@/views/cloudStore/meibang';
// 洋葱
import yangcong from '@/views/cloudStore/yangcong';

// 积分列表
import integralList from '@/views/integralManage/integralList';
// 积分详情
import integralDetail from '@/views/integralManage/integralDetail';
// 团长管理
import groupManage from '@/views/system/groupManage';
// 团长信息管理
import commission from '@/views/pay/commission';
//资产明细管理
import groupConfig from '@/views/system/groupConfig';
// 提现管理
import withdrawManage from '@/views/withdrawManage/withdrawLog';
// 好物圈管理
import shareShopping from '@/views/shareShopping/list';

// ---------------------------------------------

// 图表界面
import statistics from '@/views/charts/statistics';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
          {
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true,
                keepAlive:true
            },
            // children:[
            //   {
            //     path: '/childrenOrder',
            //     name: '子订单',
            //     component: childrenOrder,
            //     meta: {
            //       requireAuth: true
            //     }
            //   },
            // ]
        },
          {
              path: '/pay/childrenOrder/:id',
              name: '子订单',
              component: childrenOrder,
              meta: {
                requireAuth: true
              }
            },

          {
            path: '/pay/fakeOrder',
            name: '虚拟订单',
            component: fakeOrder,
            meta: {
              requireAuth: true
            }},
          {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/loginLogs',
            name: '登录日志',
            component: loginLogs,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        },{
            path: '/charts/statistics',
            name: '首页',
            component: statistics,
            meta: {
                requireAuth: true
            }
        },
        // -----------------

        {
            path: '/img/IndexSwiper',
            name: '首页轮播图',
            component: IndexSwiper,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/img/protocol',
            name: '协议管理',
            component: protocol,
            meta: {
                requireAuth: true
            }
        },
          {
            path: '/img/hotSearch',
            name: '搜索热词',
            component: hotSearch,
            meta: {
              requireAuth: true
            }
          },
        {
            path: '/system/dicType',
            name: '字典类型',
            component: dicType,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/dicList',
            name: '字典列表',
            component: dicList,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/appUser',
            name: '小程序用户管理',
            component: appUser,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/vipUser',
            name: 'vip用户管理',
            component: vipUser,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/cloudStore/aurora',
            name: '云仓',
            component: aurora,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/cloudStore/meibang',
            name: '麦帮',
            component: meibang,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/cloudStore/yangcong',
            name: '洋葱',
            component: yangcong,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/product/Typelist',
            name: '商品分类管理',
            component: Typelist,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/product/list',
            name: '商品列表管理',
            component: productList,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/product/recommendList',
            name: '商品列表管理',
            component: recommendList,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/machine/nationalFlag',
            name: '国旗管理',
            component: nationalFlag,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/pay/refund',
            name: '退货退款管理',
            component: refund,
            meta: {
                requireAuth: true
            }
        },
        // {
        //     path: '/product/factorys',
        //     name: '生产厂家',
        //     component: factorys,
        //     meta: {
        //         requireAuth: true
        //     }
        // },
        //   {
        //     path: '/product/tags',
        //     name: '产品标签',
        //     component: tags,
        //     meta: {
        //         requireAuth: true
        //     }
        // },
          {
            path: '/product/brands',
            name: '商品品牌列表',
            component: brands,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/userCenter',
            name: '个人中心',
            component: userCenter,
            meta: {
                requireAuth: true
            }
        },{
            path: '/integralManage/integralList',
            name: '积分商品',
            component: integralList,
            meta: {
                requireAuth: true
            }
        },{
            path: '/integralManage/integralDetail',
            name: '积分详情',
            component: integralDetail,
            meta: {
                requireAuth: true
            }
        },{
            path: '/system/groupManage',
            name: '团长管理',
            component: groupManage,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/groupConfig',
            name: '团长信息管理',
            component: groupConfig,
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/system/commission',
            name: '资产明细管理',
            component: commission,
            meta: {
              requireAuth: true
            }
        },
        {
            path: '/withdrawManage/withdrawLog',
            name: '提现管理',
            component: withdrawManage,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/shareShopping/list',
            name: '好物圈管理',
            component: shareShopping,
            meta: {
                requireAuth: true
            }
        },

        // ------------------- product/Typelist
    ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js